import tw from 'tailwind-styled-components';

export default tw.div`
    fixed
    mx-4
    xs:mx-auto
    top-24
    max-w-max
    z-10
    left-0
    right-0
    transform
    scale-0
    animate-grow
`